import BaseModelAPI from '../BaseModelAPI';

export default class DiesList extends BaseModelAPI {

	static entity = 'dieslist'
	static entityName = 'dies';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
